/**
 * @fileoverview Agent definition for world-event-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world event's details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.events.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-event-details-ideation-v3',
  kind: 'primitive',
  name: 'World Event Details Ideation',
  description: 'Generates creative directions for developing a world event before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.events.details',
    usedBy: ['use-world-event-details-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-event-details-generator-v3'],
  },
};
